import { usersApi } from 'entities/users';
import { CitiesListType } from 'features/getCities/types';
import { HTTP_METHODS } from 'shared/consts';

type GetCitiesParamsType = {
  search?: string;
  sort?: string;
  country_id?: number;
};

const getCitiesApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query<CitiesListType[], GetCitiesParamsType>({
      query: ({ search, sort, country_id }) => {
        const searchParams = search ? `&search_query=${search}` : '';
        const sortParams = sort ? `&sort=${sort}` : '&sort=name';
        const countryParams = country_id ? `&country_id=${country_id}` : '';
        return {
          url: `/account/admin/dicts/cities/?${searchParams}${sortParams}${countryParams}`,
          method: HTTP_METHODS.GET,
        };
      },
    }),
  }),
});

export const { useGetCitiesQuery } = getCitiesApi;
